<template>
    <div ref="self-discharge-chart-container" class="self-discharge-chart-box">
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'SelfDischargeChart',
    methods: {
        getOption() {
            const option = {
                grid: {
                    top: 20,
                    left: 40,
                    bottom: 30,
                    right: 10
                },
                xAxis: {
                    type: 'category',
                    data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,15, 16, 17, 18, 19, 20],
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    },  
                    axisLine: {
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '电池号',
                    nameLocation: 'start',
                    min: 0.05,
                    nameTextStyle: {
                        color: '#E3F0FF',
                        align: 'right'
                    }, 
                    axisLabel: {
                        color: '#E3F0FF',
                        fontSize: 12,
                        fontWeight: 700
                    }, 
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#0C89AD',
                            opacity: 0.3
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#094B85'],
                            opacity: 0.3
                        }
                    }
                },
                series: [{
                    data: [0.12, 0.11, 0.12, 0.12, 0.06, 0.07, 0.12, 0.10, 0.12, 0.11, 0.11, 0.12,0.08,0.07, 0.11, 0.12,0.10,0.12, 0.08,0.12],
                    type: 'bar',
                    itemStyle: {
                        color: 'rgba(245, 132, 188, 1)'
                    },
                    barWidth: 8
                }
               ]
            };
            return option;
        }
    },
    mounted() {
        const chartDom = this.$refs['self-discharge-chart-container'];
        const myChart = echarts.init(chartDom);
        myChart.setOption(this.getOption());
    }
}
</script>

<style lang="less" scoped>
    .self-discharge-chart-box {
        height: 100%;
        width: 100%;
    }
</style>